export default class FormSenderMailchimp {
  static URL_SENDER = '/.netlify/functions/mailchimp';

  static async sendMailchimp(__data) {
    return new Promise((resolve, reject) => {
      const emailSender = new XMLHttpRequest();
      emailSender.open('POST', this.URL_SENDER);
      emailSender.setRequestHeader('Content-Type', 'application/json');

      emailSender.onload = () => {
        if (emailSender.status === 200) {
          resolve(emailSender.responseText);
        } else {
          reject(emailSender.responseText);
        }
      };

      emailSender.onerror = () => reject("Error de xarxa");

      emailSender.send(JSON.stringify({ email: __data.email }));
    });
  }
}
